export default __webpack_public_path__ + "img/7bb13827ac70954edb3e30e3a53f1b0b.svg";